import Home from "../page/Home"
import HomePage from "../page/HomePage";
import HongKongMathsPage from "../page/HongKongMathsPage";
import HongKongPage from "../page/HongKongPage"
import SingaporePage from "../page/SingaporePage";
import AboutUsPage from "../page/AboutUsPage";
import BlogInfo from "../page/BlogInfo";
import HkClass from "../page/AdvertisingPage/Hk-class";
import HkCom from "../page/AdvertisingPage/Hk";
import HkOnlinePage from '../page/AdvertisingPage/HkOnlinePage'
import HkOnlinePage2 from "../page/AdvertisingPage/HkOnlinePage2";
import HkPage from "../page/AdvertisingPage/HkPage";
import YouTube from "../page/AdvertisingPage/YouTube";
import HkClassPuls from "../page/AdvertisingPage/HkClassPuls";
import TransitPage from "../page/AdvertisingPage/Hk-class/transitPage.jsx";
import Privacy from "../page/Privacy";
import HongKongEngPage from "../page/HongKongEngPage";
import HkEngListPage from "../page/AdvertisingPage/HkEngListPage";
import HkMathListPage from "../page/AdvertisingPage/HkMathListPage";
import FbHkChinese from "../page/AdvertisingPage/FbHkChinese";
import Tiktok from "../page/AdvertisingPage/Tiktok";
import SinobusHK from "../page/AdvertisingPage/SinobusHK";
import Thankyou from "../page/AdvertisingPage/SinobusHK/Thankyou.jsx";
import Policy from "../page/Policy";
import SinobusHKEN from "../page/AdvertisingPage/SinobusHKEN";
import Singapore1 from "../page/AdvertisingPage/Singapore-1";
const routes = [
    {
        exact: true,
        path: "/blog/:id",
        element: <BlogInfo />,
    },
    {
        exact: true,
        path: "/",
        element: <Home />,
        children: [
            {
                path: "/",
                element: <HomePage />,
            },
            {
                path: "/hongkongmaths/",
                element: <HongKongMathsPage />,
            },
            {
                path: "/hongkong/",
                element: <HongKongPage />,
            },
            {
                path: "/hongkong-English/",
                element: <HongKongEngPage />,
            },
            {
                path: "/singapore/",
                element: <SingaporePage />,
            },
            {
                path: "/aboutus/",
                element: <AboutUsPage />,
            },

        ]
    },
    {
        exact: true,
        path: "/hk-zh/",
        element: <HkClassPuls />
    },
    {
        exact: true,
        path: "/hkonlinetutoring/",
        element: <HkClass />
    },
    {
        exact: true,
        path: "/hkonlinetutoring1/",
        element: <TransitPage />
    },
    {
        exact: true,
        path: "/hkch/",
        element: <HkCom />
    },
    // 已挪出至单页面
    {
        exact: true,
        path: "/singapore1/",
        element: <Singapore1 />
    },
    // {
    //     exact: true,
    //     path: "/singapore1",
    //     element: <Singapore1 />
    // },

    {
        exact: true,
        path: "/hkonlinechinesetutoring/",
        element: <HkOnlinePage />
    },
    {
        exact: true,
        path: "/googlehkonlineclass/",
        element: <HkOnlinePage2 />
    },
    {
        exact: true,
        path: "/hk/",
        element: <HkPage />
    },
    {
        exact: true,
        path: "/Sino-busYouTube/",
        element: <YouTube />
    },
    {
        exact: true,
        path: "/privacy",
        element: <Privacy />
    },
    {
        exact: true,
        path: "/hk-english",
        element: <HkEngListPage />
    },
    {
        exact: true,
        path: "/hk-math",
        element: <HkMathListPage />
    },
    {
        exact: true,
        path: "/fb-hkchinese",
        element: <FbHkChinese />
    },
    {
        exact: true,
        path: "/SGTT",
        element: <Tiktok />
    },
    {
        exact: true,
        path: "/SinobusHK",
        element: <SinobusHK />
    },
    {
        exact: true,
        path: "/sinobusHKEN",
        element: <SinobusHKEN />
    },
    {
        exact: true,
        path: "/Thankyou",
        element: <Thankyou />
    },
    {
        exact: true,
        path: "/policy",
        element: <Policy />
    }
]
export default routes;